module.exports = __webpack_public_path__ + "img/SchuB_lip.63d553ca.png";